import mainStore from '@components/Main/store'
import { MARKETING_CENTER_PATH } from '@constant'
import { getObjValue } from '@hlj/hlj-utils'
import { HeaderView } from '@merchant-backend/common-components'
import { statistic } from '@util'
import { observer } from 'mobx-react'
import React, { Component, Fragment } from 'react'
import { Link } from 'react-router'
import styles from './style.module.less'

@observer
export default class extends Component {
  toLink = (type, name) => () => {
    statistic(name)
    window.location.href = '#/localMerchant/marketingCenter/detail/65/' + type
  }

  toDetail = (status, type, auth_status) => () => {
    if (type == '1') {
      window.location.href = '#/localMerchant/liteApp/manage'
    } else {
      if (status == '2') {
        if (auth_status == '1') {
          window.location.href = '#/localMerchant/liteApp/manage'
        } else {
          window.location.href = '#/localMerchant/liteApp/authorize'
        }
      } else {
        if (auth_status == '0' || auth_status == '2') {
          window.location.href = '#/localMerchant/liteApp/authorize'
        } else {
          window.location.href = '#/localMerchant/liteApp/manage'
        }
      }
    }
  }

  render() {
    const header = [
      <Link to={MARKETING_CENTER_PATH}>服务市场</Link>,
      '选择小程序版本'
    ]

    const {
      liteAppFee,
      shopInfo: { merchant_weapp }
    } = mainStore
    let status = getObjValue(merchant_weapp, 'status')
    let type = getObjValue(merchant_weapp, 'type')
    let auth_status = getObjValue(merchant_weapp, 'auth_status')

    return (
      <HeaderView header={header} title="小程序授权">
        <p className={styles.p1}>选择你想要的小程序</p>
        <p className={styles.p2}>
          专为婚礼行业定制的小程序软件 无需开发 一键制作
        </p>
        <ul className={styles.box}>
          <li>
            <div className={styles.topPub}>
              <p className={styles.p3}>小程序</p>
              <p className={styles.p4}>商家服务（付费）免费使用</p>
              {status != 0 && type == 1 ? (
                <Fragment>
                  <a
                    className={styles.button}
                    onClick={this.toDetail(status, type, auth_status)}
                  >
                    立即使用{' '}
                  </a>
                  <a
                    className={styles.more}
                    onClick={this.toLink('1', 'weapp_pub_icon')}
                  >
                    了解详情 >{' '}
                  </a>
                </Fragment>
              ) : (
                <Fragment>
                  <a
                    className={styles.button}
                    onClick={this.toLink('1', 'weapp_pub_icon')}
                  >
                    了解更多{' '}
                  </a>
                  <div className={styles.emptyDiv} />
                </Fragment>
              )}
            </div>
            <div className={styles.text}>
              <p>
                <span className={styles.icon_black} />商家主页展示
              </p>
              <p>
                <span className={styles.icon_black} />内容快捷分享
              </p>
              <p>
                <span className={styles.icon_black} />数据实时监控
              </p>
              <p>
                <span className={styles.icon_black} />无需申请一键使用
              </p>
            </div>
          </li>
          <li>
            <span className={styles.vip_icon1} />
            <div className={styles.topVip}>
              <p className={styles.p3}>小程序</p>
              <p className={styles.p4}>{liteAppFee}元/年</p>
              {status != 0 && type == 2 ? (
                <Fragment>
                  <a
                    className={styles.button}
                    onClick={this.toDetail(status, type, auth_status)}
                  >
                    立即使用
                  </a>
                  <a
                    className={styles.more}
                    onClick={this.toLink('2', 'weapp_pro_icon')}
                  >
                    了解详情 >
                  </a>
                </Fragment>
              ) : (
                <Fragment>
                  <a
                    className={styles.button}
                    onClick={this.toLink('2', 'weapp_pro_icon')}
                  >
                    了解更多
                  </a>
                  <div className={styles.emptyDiv} />
                </Fragment>
              )}
            </div>
            <div className={styles.text}>
              <p>
                <span className={styles.icon_black} />商家主页展示
              </p>
              <p>
                <span className={styles.icon_black} />内容快捷分享
              </p>
              <p>
                <span className={styles.icon_black} />数据实时监控
              </p>
              <p style={{ color: '#b67300' }}>
                <span className={styles.icon_gold} />支持微信搜索
              </p>
              <p style={{ color: '#b67300' }}>
                <span className={styles.icon_gold} />自有品牌曝光
              </p>
              <p style={{ color: '#b67300' }}>
                <span className={styles.icon_gold} />独立微信小程序
              </p>
              <p style={{ color: '#b67300' }}>
                <span className={styles.icon_gold} />小程序私信客服
              </p>
            </div>
            <div className={styles.vip_icon2} />
          </li>
        </ul>
      </HeaderView>
    )
  }
}
